module.exports = __webpack_public_path__ + "img/1483001324.b519876e.jpg";